export type UpdateProjectStakeholdersRequest = {
  pjtId: string;
  pjtTypeCd: string;
  stakeholderList: UpdateRequestStakeholder[];
  updateDateTime: string;
};

export type UpdateRequestStakeholder = {
  stkhldrId: string;
  primFlg: string;
  roleCd: string;
  teamCd: string;
  userId: string;
  stkhldrNote?: string;
  index: number;
};
